










































































































import { Component, Mixins, Vue } from 'vue-property-decorator'
import * as weixin from '@ivy/fts/weixin'
import * as utils from '@ivy/fts/utils'
import orderDetail from './order.vue'
import goodsMixin from './goodsMixin'
import * as util from './util'
import { addStatistics } from './require'

@Component({
  components: {
    orderDetail,
  },
})
export default class Collage extends Mixins(goodsMixin) {
  showSkusPopup: boolean = false
  showChosePopup: boolean = false
  orderParams: any = {}

  get floorPrice() {
    if (!this.spuData.skuInfos) return { sale_price: 0, origin_price: 0 }
    let prices = this.spuData.skuInfos.sort((a, b) => a.salePrice - b.salePrice)
    return {
      sale_price: (+prices[0].salePrice).toFixed(2),
      origin_price: 0,
    }
  }

  async mounted() {
    util.addYMPutData()
    utils.cacheSet('goodsPopUrl', window.location.href)
  }

  async getuserinfo(e) {
    // type: 1 === 用户点击原价购买  ，2 === 一键参团
    let type = parseInt(e.currentTarget.dataset.target, 10)
    // if (this.skuData.id) {
    //   type === 1 && this.$Toast('系统已帮您自动参团')
    //   this.showSkusPopup = true
    //   return
    // }
    type === 1 && this.$Toast('系统已帮您自动参团，请先选择课程~')
    this.showChosePopup = true
    // let offsetTop = document.getElementById('skubox').offsetTop - 170
    // window.scrollTo({ top: offsetTop, behavior: 'smooth' })
  }
  onSelect(skuId) {
    this.skuData = this.spuData.skuInfos.filter(s => s.id === skuId)[0]
    this.showSkusPopup = true
    this.showChosePopup = false
    this.orderParams = {
      // order页需要的一些参数，为兼容之前路由带参数的方式.
      channelId: this.channelId,
      spuId: this.spu.id,
      actId: this.actId,
      skuId: this.skuData.id,
      type: this.goodsType,
      discountInfo: this.actConfig.discount_info,
    }
  }
}
